(function () {
  const SELECTORS = {
    content: '.article-template__content',
    tocContainer: '#table-of-contents',
    scrollIndicator: '#toc-scroll-indicator',
    tocBtn: '#table-of-contents-btn',
    closeBtn: '#toc-close-btn',
    overlay: '#toc-overlay',
  };
  const MOBILE_BREAKPOINT = 999;
  const SCROLL_THRESHOLD = 10;

  function createHeadingId(text, index) {
    return text.replace(/\s+/g, '-').replace(/[^\w\-]/g, '') + '-' + index;
  }

  function buildTocList(headings) {
    const tocList = document.createElement('ul');
    tocList.className = 'toc-list';
    let h2Index = 0;
    let h3Index = 0;
    let currentH2 = 0;

    headings.forEach((heading, index) => {
      const headingText = heading.textContent.trim();
      const isH3 = heading.tagName.toLowerCase() === 'h3';

      if (isH3) {
        h3Index++;
      } else {
        h2Index++;
        currentH2 = h2Index;
        h3Index = 0;
      }

      const indexedText = isH3 ? `${currentH2}-${h3Index}. ${headingText}` : `${h2Index}. ${headingText}`;
      const headingId = createHeadingId(headingText, index);
      heading.id = headingId;

      const listItem = document.createElement('li');
      listItem.className = isH3 ? 'toc-item toc-item-h3' : 'toc-item';
      const link = document.createElement('a');
      link.href = '#' + headingId;
      link.textContent = indexedText;
      listItem.appendChild(link);
      tocList.appendChild(listItem);
    });

    return tocList;
  }

  function setupScrollIndicator(container) {
    const indicator = document.querySelector(SELECTORS.scrollIndicator);
    if (!indicator) return;

    function updateVisibility() {
      indicator.style.display = container.scrollHeight > container.clientHeight ? 'block' : 'none';
    }

    let hasScrolled = false;
    container.addEventListener('scroll', function () {
      if (!hasScrolled && container.scrollTop > SCROLL_THRESHOLD) {
        indicator.style.display = 'none';
        hasScrolled = true;
      }
    });
    window.addEventListener('resize', function () {
      if (!hasScrolled) updateVisibility();
    });
    setTimeout(updateVisibility, 100);
  }

  function setupMobileToc(container, tocBtn, closeBtn, overlay) {
    if (!tocBtn || window.innerWidth > MOBILE_BREAKPOINT) return;

    if (closeBtn) closeBtn.classList.add('close-btn-active');

    function openToc(e) {
      if (e) e.preventDefault();
      container.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeToc() {
      container.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    tocBtn.addEventListener('click', openToc);
    if (closeBtn) closeBtn.addEventListener('click', closeToc);
    if (overlay) overlay.addEventListener('click', closeToc);

    container.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeToc);
    });

    document.addEventListener('click', function (e) {
      const isOutsideToc = !container.contains(e.target);
      const isNotTocButton = !tocBtn.contains(e.target);
      if (isOutsideToc && isNotTocButton && container.classList.contains('active')) {
        closeToc();
      }
    });
  }

  function init() {
    const contentDiv = document.querySelector(SELECTORS.content);
    const tocContainer = document.querySelector(SELECTORS.tocContainer);
    if (!contentDiv || !tocContainer) return;

    const headings = contentDiv.querySelectorAll('h2, h3');
    if (headings.length === 0) return;

    tocContainer.appendChild(buildTocList(headings));
    setupScrollIndicator(tocContainer);
    setupMobileToc(
      tocContainer,
      document.querySelector(SELECTORS.tocBtn),
      document.querySelector(SELECTORS.closeBtn),
      document.querySelector(SELECTORS.overlay)
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
